// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"-name__-loca-__1jYc3","Label":"-name__-loca-__33Z-p","Less":"-name__-loca-__377MJ","More":"-name__-loca-__28-hQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.css
// module id = 157
// module chunks = 0